import { AvailableItemsFieldBase } from 'models/forms/fields/AvailableItemsField';
import { FieldMetadataBase } from 'models/forms/fields/FieldMetadataBase';
import type { FieldFormatter } from 'models/forms/fields/utils';

export type RadioButtonsFieldData = string;

export type RadioButtonsFieldMetadata = AvailableItemsFieldBase<string> &
  FieldMetadataBase<'RadioButtonsField', RadioButtonsFieldData>;
export const radioButtonsFieldFormatter: FieldFormatter<RadioButtonsFieldMetadata> = {
  isHandled: field => field.type === 'RadioButtonsField',
  withDefault: f => f,
};
